import {getUrlParams} from '@/utils/urlParams';

const urlParams = getUrlParams();
const html = document.documentElement;
const footer = document.querySelector('.footer');
const chatBarTemplate = document.querySelector('#chat-bar-template');
let chatBar;

if (chatBarTemplate) {
	chatBar = chatBarTemplate.content.firstElementChild.cloneNode(true);
}

/*
	Callback function that is called immediately after JivoChat is loaded
*/
window.jivo_onLoadCallback = () => {
	if (chatBar && (urlParams._showChatBar || jivo_api.chatMode() === 'online')) {
		chatBar.classList.add('jivo_custom_widget'); // this is necessary for jivo to hide the default widget
		chatBar.classList.add('chat-bar--online');
		chatBar.addEventListener('click', e => {
			e.preventDefault();
			e.stopImmediatePropagation();
			jivo_api.open();
		});
		document.body.insertBefore(chatBar, footer);
	}
}

/*
	Callback function jivo_onOpen and jivo_onClose called whenever the chat window JivoChat is expanded or collapsed by the user or by the proactive invitations rule.
*/
window.jivo_onOpen = () => {
	html.classList.add('show--jivo-chat');
}
window.jivo_onClose = () => {
	html.classList.remove('show--jivo-chat');
}